import { useQuery } from '@zg-rentals/react-query5';
import { useDispatch, useSelector } from 'react-redux';

import makeRequest from '../../utils/makeRequestUtils';
import useRequestConfig from '../useRequestConfig';
import { RENTAL_MANAGER_API_V2_PREFIX } from '../../constants/RouteConstants';
import ListingRecs from '../../model/ListingRecs';
import RecommendationsActions from '../../actions/Recommendations';
import { GET_LISTING_RECS } from '../../constants/RecommendationsConstants';
import TimeConstants from '../../constants/TimeConstants';

/**
 * when using this query we need to sync data to the redux store.
 * call syncCurrentProperty on data change
 *
 *   useEffect(() => {
 *     if (listingRecommendationsData) {
 *       syncRecommendations({ data: listingRecommendationsData, isMultifamily, dispatch });
 *     }
 *   }, [listingRecommendationsData]);
 */
const useGetListingRecommendations = ({ listingAlias, fields = null, isMultifamily = false }, queryOptions = {}) => {
  const dispatch = useDispatch();
  const requestConfig = useRequestConfig();

  // @ts-expect-error
  const { ZRM_USE_UPLIFT_BRAIN_TEST_DATA } = useSelector((state) => state.app.cookieEnabledServices);

  const queryFn = () =>
    makeRequest({
      dispatch,
      endpoint: `${RENTAL_MANAGER_API_V2_PREFIX}/users/properties/recommendations`,
      requestConfig,
      config: {
        params: {
          useUpliftBrainTestData: ZRM_USE_UPLIFT_BRAIN_TEST_DATA,
          propertyId: listingAlias,
          ...(fields && { fields }),
        },
      },
    });

  return useQuery({
    queryKey: [GET_LISTING_RECS, listingAlias, fields, isMultifamily],
    queryFn: async () => {
      const data = await queryFn();
      const normalizedData = ListingRecs(data);

      return normalizedData;
    },
    enabled: Boolean(listingAlias),
    staleTime: TimeConstants.SECONDS_10,
    ...queryOptions,
  });
};

const syncRecommendations = ({ data, isMultifamily = false, dispatch }) => {
  const normalizedData = ListingRecs(data);

  dispatch(RecommendationsActions.updateRecommendations(normalizedData, isMultifamily));
};

export { syncRecommendations, useGetListingRecommendations };
